module.exports = __webpack_public_path__ + "static/logo-title-white-bg-75d4bfdacb6be151903cd576065d4241.png";